// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__JDjUN","pink":"About_pink__DOpB+","green":"About_green__YICS+","skills":"About_skills__aGQMA"};